import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class HaloConfigEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspHaloConfig),
            mergeMap(() =>
                this.ajax.get('/api/octiga/v3/msp/halo/config').pipe(
                    map((data) => actions.loadMspHaloConfigSuccess({ data })),
                    catchError((error) => of(actions.loadMspHaloConfigFailure({ error }))),
                ),
            ),
        ),
    );

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.updateMspHaloConfig),
            mergeMap(({ data }) =>
                this.ajax.put('/api/octiga/v3/msp/halo/config', data).pipe(
                    map(() => actions.updateMspHaloConfigSuccess()),
                    catchError((error) => of(actions.updateMspHaloConfigFailure({ error }))),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
